module.exports = __webpack_public_path__ + "img/sos-type-grey.e3ea1c79.png";